

import {
      Box, FormHelperText, TextField, Typography, FormControlLabel, Checkbox, Button, IconButton, InputAdornment, OutlinedInput, List, ListItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextareaAutosize, Select, MenuItem, FormControl, RadioGroup, Radio, Tabs, Tab, Switch, styled, Modal, Menu, Collapse, Stack, Pagination, SwipeableDrawer, Accordion,
      AccordionActions, AccordionSummary, AccordionDetails, Tooltip
} from "@mui/material";

import { Link } from "react-router-dom";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import OwlCarousel from 'react-owl-carousel3';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { motion } from "framer-motion"






export default {
      Box,
      FormHelperText,
      TextField,
      Typography,
      FormControlLabel,
      Checkbox,
      Button,
      IconButton,
      InputAdornment,
      OutlinedInput,
      VisibilityOff,
      Visibility,
      Link,
      List,
      ListItem,
      Table,
      TableBody,
      TableCell,
      TableContainer,
      TableHead,
      TableRow,
      Paper,
      TextareaAutosize,
      Select,
      MenuItem,
      FormControl,
      RadioGroup,
      Radio,
      Tabs,
      Tab,
      Switch,
      styled,
      Modal,
      Menu,
      ExpandLess,
      ExpandMore,
      Collapse,
      Stack,
      Pagination,
      SwipeableDrawer,
      OwlCarousel,
      Accordion,
      AccordionActions,
      AccordionSummary,
      AccordionDetails,
      ExpandMoreIcon,
      motion,
      Tooltip
};
